export default __webpack_public_path__ + "static/museumDisplay-32008da5b833b2fb136f0dc301fe86e4.svg";